/*!
 * JavaScript for GAYL Donate Ticketing Form
 * Give as you Live Ltd
 */

// Import JavaScript modules
import 'Vendor/parsleyjs';

// Import modules
const TicketingForm = require('Scripts/ticketing-form/ticketing-form');
const FormUtils     = require('Scripts/common/form-utils');
const Loader        = require('Scripts/common/loader');

// Define groups of modules - the group name is set in your template ($jsModuleGroup). 
// This is just a nicer way to load JS on specific pages without looking at the path/params
// To initiate a group, use the #module macro. E.g. #module("my-group") would add 'my-group' from the groups below.
const moduleGroups = {
	// Available on every page
	'global': [FormUtils],
	"ticketing-form": [], // Empty module group to suppress warnings, group exists on the /purchase page.
};

Loader.load(moduleGroups);